import { Database } from "@nozbe/watermelondb";
import ProductKit from "../../../../utilities/data/model/ProductKit";
import SaleItem from "../../../../utilities/data/model/SaleItem";
import Product from "../../../../utilities/data/model/Product";

export async function fetchSaleKitItemDetails(
  database: Database,
  productKit: ProductKit,
  saleItem: SaleItem
) {
  const items = await productKit.items.fetch();

  const kitItemDetails = await Promise.all(
    items.map(async (kitItem) => {
      let componentProduct;

      const overrideProductId =
        saleItem.metadata?.components?.[kitItem.id!]?.productId;

      if (!!overrideProductId) {
        componentProduct = await database
          .get<Product>("products")
          .find(overrideProductId);
      } else {
        componentProduct = await kitItem.product;
      }

      return {
        kitItem,
        product: componentProduct,
      };
    })
  );

  return kitItemDetails;
}
